import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Programmesleft from './ProgrammesleftEle'
import { Container, Row, Col,Table } from 'react-bootstrap';


function MtechEle() {
  return (
    <section className="project-detail">
      <Container>
        <Row>
          <Col md={4} className='c-left custom-padding-color mb-4'>
            <Programmesleft activeIndex={4}/>
            
          </Col>

          <Col md={8} className='c-right'>
           
           
            <div className="text-center mb-2">
              <h3>M.S (Research)</h3>
              </div>
            <p>
              IT Tirupati offers M.S (Research) program in the following Departments: 
            </p>


            <ul className='myulcustarrow'>
              <li> Chemical Engineering</li>
              <li> Civil & Environmental Engineering</li>
              <li> Computer Science & Engineering</li>
              <li> Electrical Engineering</li>
              <li> Mechanical Engineering</li>
            </ul>
     
            <p>
              For more information, please visit department and faculty research profiles.
            </p>
            <p>
              For admissions related information  
          
              <Link to="/ms-admission" target="_blank" rel="noopener noreferrer" className='c-link'>
                            click here
                </Link>
         
            </p>
          </Col>
        </Row>
      </Container>

    </section>
  );
}

export default MtechEle;
